import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { Component, HostListener } from '@angular/core';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
})
export class PagesComponent {
  statusSearch = false;
  ocultarFooter = false;
  ocultarNavbar = false;

  constructor(private router: Router, private location: Location) {
    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((val) => {

      let path = this.location.path();
      // console.log(path);
      // Paginas donde no mostrará header ni footer
      let pages = ['login', 'registro', 'reset-password', 'olvido'];

      this.ocultarFooter = false;
      this.ocultarNavbar = false;

      pages.forEach((pag) => {
        if (path.indexOf(pag) > -1) {
          this.ocultarFooter = true;
          this.ocultarNavbar = true;

          return;
        }
      });
    });
  }

  // @HostListener('document:click', ['$event']) documentClick($event) {
  //   this.statusSearch = !this.statusSearch;
  // }
}
